<!--
 @description 作业平台---历史任务页
 @author xiehan
 @date 2018/10/23
-->
<template>
  <div class="history__content">
    <g-back :history="history"></g-back>
    <div class="mt-base">
      <el-form ref="searchForm" :model="searchForm" :inline="true">
        <el-form-item :label="$t('platform.type')" prop="type" label-width="36px">
          <g-select :list="select_command" v-model="searchForm.type" :defaultAll="true"></g-select>
        </el-form-item>
        <el-form-item :label="$t('platform.toolName')" prop="toolName" label-width="70px">
          <el-input v-model="searchForm.toolName"></el-input>
        </el-form-item>
        <el-form-item :label="'IP'" prop="ip" label-width="20px">
          <el-input v-model="searchForm.ip"></el-input>
        </el-form-item>
        <el-form-item input-width="0">
          <el-button
            type="primary"
            @click="search(true)"
            v-g-rac="gRac('platformHistory@search')" 
            v-text="$t('common.search')"></el-button>
        </el-form-item>
      </el-form>
      <el-table-extend
        :data="tableData"
        :head="tableHead"
        :currentChange="currentChange"
        :sizeChange="sizeChange"
        border>
        <template slot="control-column" slot-scope="{data}">
          <el-table-extend-control 
            :control="tableControl" 
            :data="data" 
            :label="$t('platform.table.operate')">
          </el-table-extend-control>
        </template>
      </el-table-extend>
      <el-dialog :closeOnClickModal="false"
        :title="$t('common.detail')"
        :visible.sync="dialogDetailShow"
        width="600px">
        <el-form label-width="80px" input-width="400px">
          <el-form-item :label="$t('platform.type')">
            <span v-text="detailForm.type"></span>
          </el-form-item>
          <el-form-item :label="$t('platform.toolName')">
            <span v-text="detailForm.toolName"></span>
          </el-form-item>
          <el-form-item :label="$t('platform.executeTime')">
            <span v-text="detailForm.startTime"></span>
          </el-form-item>
          <el-form-item :label="$t('platform.table.operator')">
            <span v-text="detailForm.operator"></span>
          </el-form-item>
          <el-form-item label="IP">
            <span v-text="detailForm.ip"></span>
          </el-form-item>
          <el-form-item :label="$t('platform.codeDetail')">
            <span v-text="detailForm.content" class="detail-code-wrap"></span>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogDetailShow = false" v-text="$t('common.close')"></el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import platformBiz from '@/logic/continuousDelivery/platformBiz'
  import TimeFormat from '@/utils/timeFormat'
  export default {
    mixins: [rac, dic],
    data () {
      return {
        history: [],
        searchForm: {
          toolName: '',
          ip: '',
          type: ''
        },
        detailForm: {},
        select_command: {},
        currentPage: 1,
        perPageCount: 10,
        tableData: {},
        tableHead: [],
        tableControl: [{
          rac: () => this.gRac('platformHistory@check'),
          label: this.$t('common.check'),
          callback: (row, index, data) => {
            this.dialogDetailShow = true
            this.detailForm = row
          }
        }],
        dialogDetailShow: false
      }
    },
    components: {},
    methods: {
      search (fromClick = false) {
        if (fromClick) {
          this.currentPage = 1
          this.perPageCount = 10
        }
        let searchObj = {
          currentPage: this.currentPage,
          perPageCount: this.perPageCount
        }
        for (let i in this.searchForm) {
          if (this.searchForm[i]) {
            searchObj[i] = this.searchForm[i]
          }
        }
        platformBiz.getHisPlatform(searchObj).then((data) => {
          let arr = data
          arr.dataList.map((item) => {
            if (item.ip.length > 0) {
              item.ip = item.ip.join(',')
            } else {
              item.ip = ''
            }
            item.startTime = TimeFormat.getFormatTime(item.startTime)
            item.endTime = TimeFormat.getFormatTime(item.endTime)
          })
          this.tableHead = [
            { key: 'type',
              label: this.$t('platform.table.type'),
              width: '100px',
              formatter: 'Dictionary',
              formatterDic: this.select_command },
            { key: 'ip', label: this.$t('platform.table.ip'), showOverflowTooltip: true },
            { key: 'toolName', label: this.$t('platform.table.toolName') },
            { key: 'startTime', label: this.$t('platform.table.startTime') },
            { key: 'endTime', label: this.$t('platform.table.endTime') },
            { key: 'operator', label: this.$t('platform.table.operator'), width: '120px' }
          ]
          this.tableData = arr
        })
      },
      currentChange (val) {
        this.currentPage = val
        this.search()
      },
      sizeChange (val) {
        this.currentPage = 1
        this.perPageCount = val
        this.search()
      },
      setHistory () {
        this.history = []
        this.history.push({ name: this.$t('platform.historyTask') })
      },
      async waitCommand () {
        await this.dGetDictionaryByCode('commandType')
        this.select_command = { ...this.dDictionary.commandType }
        this.search()
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'platformHistory' && from.name === 'platform') {
          this.$refs.searchForm.resetFields()
          this.waitCommand()
        }
      }
    },
    mounted () {
      this.setHistory()
      this.waitCommand()
    }
  }
</script>

<style scoped>
  .detail-code-wrap {
    white-space: pre-wrap;
    display: inline-block;
    overflow: scroll;
    max-height: 240px;
    width: 100%;
  }
</style>